export const STORE = "COLLECTED_PAYMENTS";
export const SET_ACTUAL_TRANSACTION = "SET_ACTUAL_TRANSACTION";
export const GET_ACTUAL_TRANSACTION = "GET_ACTUAL_TRANSACTION";
export const GET_FROM = "GET_FROM";
export const GET_TO = "GET_TO";
export const SET_FROM = "SET_FROM";
export const SET_TO = "SET_TO";
